import { PayloadActionData } from 'models';
import { AC_ACTIVITY_LOG_LIST_PARAMS } from 'models/activity-logs';

export const GET_ACTIVITY_LOG_LIST_REQUEST: string =
  'GET_ACTIVITY_LOG_LIST_REQUEST';

export const getActivityLogListAction = (
  payload?: PayloadActionData<AC_ACTIVITY_LOG_LIST_PARAMS>
) => {
  return {
    type: GET_ACTIVITY_LOG_LIST_REQUEST,
    payload,
  };
};
